(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-style-1"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        this.loadRecommendations()
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    normalise(value) {
      return (value || '').toLocaleLowerCase('lt-LT').trim();
    }

    seriesFromTitle(title) {
      const ignored = new Set([
        'komoda', 'spinta', 'lova', 'sofa', 'kampas', 'fotelis', 'pufas', 'stalas', 'staliukas',
        'vitrina', 'lentyna', 'sekcija', 'suoliukas', 'kėdė', 'kedė', 'čiužinys', 'ciuzinys',
        'naktinis', 'kavos', 'rašomasis', 'rasomasis', 'valgomojo', 'tv', 'rtv', 'aukšta', 'auksta',
        'žema', 'zema', 'minkštas', 'minkstas', 'minkšta', 'minksta', 'dvivietė', 'dviviete',
        'trivietė', 'triviete', 'kampinė', 'kampine', 'pastatoma', 'pakabinama'
      ]);

      const words = (title || '').replace(/[|,/()]/g, ' ').split(/\s+/).filter(Boolean);
      return words.find(word => {
        const clean = this.normalise(word).replace(/^[-–—]+|[-–—]+$/g, '');
        return clean.length > 2 && !ignored.has(clean) && !/^\d/.test(clean) && !/^[a-z]{0,3}-?\d+[a-z-]*$/i.test(clean);
      }) || '';
    }

    async fetchSection(url) {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
      const html = document.createElement('div');
      html.innerHTML = await response.text();
      return html;
    }

    addCards(source, target, seen, limit, expectedSeries = '') {
      source.querySelectorAll('[data-recommendation-card]').forEach(item => {
        if (target.children.length >= limit) return;
        const id = item.dataset.productId;
        if (!id || id === this.dataset.productId || seen.has(id)) return;

        if (expectedSeries) {
          const itemSeries = item.dataset.productSeries || this.seriesFromTitle(item.dataset.productTitle);
          if (this.normalise(itemSeries) !== this.normalise(expectedSeries)) return;
        }

        seen.add(id);
        target.appendChild(item.cloneNode(true));
      });
    }

    async loadRecommendations() {
      const limit = Number(this.dataset.limit) || 4;
      const explicitSeries = (this.dataset.productSeries || '').trim();
      const series = explicitSeries || this.seriesFromTitle(this.dataset.productTitle);
      const seen = new Set([this.dataset.productId]);
      const cards = document.createElement('ul');
      cards.className = this.dataset.gridClass;
      cards.setAttribute('role', 'list');

      if (series) {
        const query = encodeURIComponent(series);
        try {
          const seriesHtml = await this.fetchSection(`${window.Shopify.routes.root}search?q=${query}&type=product&options%5Bprefix%5D=last&section_id=series-recommendation-cards`);
          this.addCards(seriesHtml, cards, seen, limit, series);
        } catch (error) {
          console.warn('Series recommendations unavailable', error);
        }
      }

      let collections = [];
      try { collections = JSON.parse(this.dataset.productCollections || '[]'); } catch (error) { /* Ignore malformed optional data. */ }

      for (const handle of collections) {
        if (cards.children.length >= limit) break;
        if (!handle || handle === 'all' || handle === 'frontpage') continue;
        try {
          const collectionHtml = await this.fetchSection(`${window.Shopify.routes.root}collections/${encodeURIComponent(handle)}?section_id=series-recommendation-cards`);
          this.addCards(collectionHtml, cards, seen, limit);
        } catch (error) {
          console.warn('Collection recommendations unavailable', error);
        }
      }

      if (cards.children.length < limit) {
        try {
          const fallbackHtml = await this.fetchSection(this.dataset.url);
          const recommendations = fallbackHtml.querySelector('product-recommendations');
          if (recommendations) this.addCards(recommendations, cards, seen, limit);
        } catch (error) {
          console.warn('Shopify recommendations unavailable', error);
        }
      }

      if (cards.children.length) {
        const heading = document.createElement('h2');
        heading.className = this.dataset.headingClass;
        heading.textContent = this.dataset.heading;
        this.replaceChildren(heading, cards);
        this.classList.add('product-recommendations--loaded');
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
